/** Available access card types */
export enum AccessCardTypeEnum {
  /** FRM test mock card (for tests, available only on admin tenant) */
  TEST_MOCK_CARD = 'TEST_MOCK_CARD',
  /** "EM-Marine" card */
  EM_MARINE = 'EM_MARINE',
  /** "Mifare" card */
  MIFARE = 'MIFARE',
}
